import React from "react";

import ShareButtons from "./ShareButtons";

export interface IShareButtonsProps {
  title?: string;
  description?: string;
  images?: any[];
  slug?: string;
  theme?: "default" | "dark" | "light";
  preCopy?: string;
  data: any;

}

const ShareButtonsHOC = (props: IShareButtonsProps) => {
  const {
    title,
    description,
    slug,
    theme,
    preCopy,
    data: server_data,
    images,
  } = props;
  const [contentCollection, setContentCollection] = React.useState<any>(
    server_data?.contentCollection
  );

  const themeD = !theme ? "default" : theme;

  // const { isLoading, data } = useShareButtonsQuery();

  // if (isLoading || (!data?.settingsCollection && !server_data)) {
  //   return <></>;
  // }

  // React.useEffect(() => {
  //   setContentCollection(
  //     data?.settingsCollection?.items[0]?.shareButtonDefault?.contentCollection
  //   );
  // }, [data]);

  // const contentCollection = !server_data
  //   ? data?.settingsCollection?.items[0]?.shareButtonDefault?.contentCollection
  //   : server_data.fields.shareButtonDefault.contentCollection;

  // return <Settings {...data.settingsCollection.items[0]} />;

  //console.log("contentCollection", contentCollection);

  const collection = {
    __typename: contentCollection?.__typename,
    items: contentCollection?.items,
  } as any;
  return <ShareButtons {...collection} {...props} />;
};

export default ShareButtonsHOC;
